module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-11.6622df8b.png";